import { configure } from 'safe-stable-stringify'

export const safeStringify = configure({
  bigint: true,
})
